import React, { ReactElement } from 'react'
import Sport1Logo from '../Theme/Logos/Sport1'
import Sport1PlusLogo from '../Theme/Logos/Sport1Plus'
import ESports1Logo from '../Theme/Logos/eSports1'
import { ChannelLogoTypes } from '../Theme/Logos/LogoInterfaces'

export const getLogo = (logoType: ChannelLogoTypes, logoWidth: number): ReactElement => {
    switch (logoType) {
        case 'sport1':
            return <Sport1Logo width={logoWidth} type="OnDark" />
        case 'sport1plus':
            return <Sport1PlusLogo width={logoWidth} type="OnDark" />
        case 'esports1':
            return <ESports1Logo width={logoWidth} type="OnDark" />
    }
}
